import React, { useCallback, useEffect, useState } from 'react';
import { fetchMembershipReports } from '../../../services/MasterAdmin/membershipService';
import MembershipPanelShell from './MembershipPanelShell';
import { MembershipError, MembershipLoading } from './MembershipAlerts';

const MembershipReportsPanel: React.FC = () => {
  const [reports, setReports] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setReports(await fetchMembershipReports());
    } catch (e: any) {
      setError(e?.response?.data?.message || e?.message || 'Failed to load reports');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const cards = reports
    ? [
        { label: 'Purchases', value: reports.purchases },
        { label: 'Revenue', value: `₹${Number(reports.revenue || 0).toLocaleString()}` },
        { label: 'Credits consumed', value: reports.creditsConsumed },
      ]
    : [];

  return (
    <MembershipPanelShell title="Reports">
      <MembershipError message={error} />
      {loading ? <MembershipLoading /> : null}
      {!loading && reports ? (
        <div className="grid gap-4 sm:grid-cols-3">
          {cards.map((card) => (
            <div
              key={card.label}
              className="rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800"
            >
              <p className="text-xs font-medium uppercase tracking-wide text-gray-400">{card.label}</p>
              <p className="mt-1 text-2xl font-bold text-gray-900 dark:text-white">{card.value}</p>
            </div>
          ))}
        </div>
      ) : null}
    </MembershipPanelShell>
  );
};

export default MembershipReportsPanel;
